<template>
  <v-card class="colored-header ma-0 pa-0">
    <v-card-text class="fill-height ma-0 pa-0">
      <v-container class="fill-height full-width card-container mx-0 py-0">
        <v-row v-if="!error" class="header-row dense">
          <v-col cols="10" class="text-h6 pb-0">
            {{ title }}
          </v-col>
          <v-col cols="2" class="text-right pb-0">
            <v-btn v-if="showLink" text icon small color="secondary" @click.native.stop.prevent="invokeLink">
              <v-icon>fa-link</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!error" align="center" justify="center" class="content-row">
          <v-col cols="12">
            <div v-if="working" class="text-center">
              <v-progress-circular :size="100" :width="10" color="secondary" indeterminate> </v-progress-circular>
            </div>
            <slot v-else> </slot>
          </v-col>
        </v-row>
        <v-row v-if="error" align="center" justify="center" class="content-row">
          <v-icon size="48px" color="red" left>fa-circle-exclamation</v-icon
          >{{ this.generateMessage(this.error, 'Error loading query/card.') }}
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { ExceptionMessage } from './ExceptionMessage'

export default {
  name: 'DashboardCard',
  props: {
    working: {
      type: Boolean,
      description: 'Controls the spinner display.',
      default: true
    },
    showLink: {
      type: Boolean,
      description: 'Controls visibility of the link icon.',
      default: false
    },
    linkRoute: {
      type: String,
      description: 'Route to use when showing link button.',
      default: ''
    },
    showSettings: {
      type: Boolean,
      description: 'Controls visiblity of the settings icon.',
      default: false
    },
    title: {
      type: String,
      description: 'Card title',
      default: ''
    },
    subTitle: {
      type: String,
      description: 'Card subtitle',
      default: ''
    },
    error: {
      type: Object,
      description: 'Error object if error during load.',
      default: function () {
        return null
      }
    }
  },
  methods: {
    generateMessage: function (err, def) {
      let message = ExceptionMessage.generateMessage(err, def)
      if (message) return message.text
      else return def
    },
    invokeSettings: function () {
      this.$emit('settings')
    },
    invokeLink: function () {
      this.$emit('link', this.linkRoute)
    }
  }
}
</script>
<style scoped lang="scss">
.colored-header {
  border-top: 10px solid var(--v-accent-base) !important;
  border-top-right-radius: 4px !important;
  border-top-left-radius: 4px !important;
  border-bottom: 10px solid white !important;
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
  max-height: 350px;
  height: 350px;
}

.card-container {
  max-width: 100% !important;
}

.header-row {
  height: 42px !important;
}

.content-row {
  height: calc(100% - 42px) !important;
}
.icon-column {
  width: 32px !important;
  height: 32px !important;
}
</style>
